module.exports = __webpack_public_path__ + "img/import.e21a017e.png";